import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import DceAjax from "dce-ajax/lib/ajax/DceAjax";
import Logger from "dce-logger/lib/logger/Logger";
import DceAjaxResponse from "dce-ajax/lib/ajax/DceAjaxResponse";
import EventsContainer from "./utils/EventsContainer";

interface AjaxFormProps {
    dialog: boolean,
    dialogId?: string
}

@Dce("AjaxForm")
export default class AjaxForm extends DceComponent<AjaxFormProps> {

    private static EVENT_SUBMIT = "submit";
    private static EVENT_ERRORS = "errors";
    private static EVENT_SAVE = "save";

    protected logger = Logger.of("AjaxForm");

    private form: JQuery<HTMLElement>;

    private events: EventsContainer<AjaxForm>;

    private _formResponse:DceAjaxResponse;
    private _formSaved:boolean = false;

    constructor(elem: DceHTMLElement, props: AjaxFormProps) {
        super(elem, props);
        this.form = $(elem);

        this.form.on('submit', (e:JQuery.Event) => this.submit(e));

        this.events = new EventsContainer<AjaxForm>(this, elem);

    }

    public isDialogForm(): boolean{
        return this.props.dialog;
    }

    public isFormForDialogWithId(id: string): boolean{
        if(this.props.dialogId){
            if(this.props.dialogId == id){
                return true;
            }
            return false;
        }
        return true;
    }

    /**
     * Pop poprawnym zapisaniu
     * @param callback
     */
    public addOnSave(callback: (a: AjaxForm, e: HTMLElement) => void){
        this.events.register(AjaxForm.EVENT_SAVE, callback);
    }

    /**
     * Po zwrotce z serwera z błędami
     * @param callback
     */
    public addOnErrors(callback: (a: AjaxForm, e: HTMLElement) => void){
        this.events.register(AjaxForm.EVENT_ERRORS, callback);
    }

    /**
     * Przed wysłaniem zapytania
     * @param callback
     */
    public addOnSubmit(callback: (a: AjaxForm, e: HTMLElement) => void){
        this.events.register(AjaxForm.EVENT_SUBMIT, callback);
    }

    public submit(e: JQuery.Event|null){
        if(e) {
            e.preventDefault();
        }

        if(this.form.hasClass('loading')){
            return;
        }

        this.form.addClass('loading');

        this.events.call(AjaxForm.EVENT_SUBMIT);

        let formData = new FormData(this.form[0] as HTMLFormElement);
        let url = this.form.attr('action');

        DceAjax.getInstance()
            .post(url, formData)
            .then((resp:DceAjaxResponse) => {
                this.form.removeClass('loading');

                this.logger.debug("formresp", resp);

                if(resp.hasResponse()){

                    let newblock = $(resp.response);

                    if(newblock.is('form')) {

                        newblock.removeAttr('dce');

                        var attributes = newblock.prop("attributes");

                        for (var i = 0; i < attributes.length; i++) {
                            this.form.attr(attributes[i].nodeName, attributes[i].nodeValue);
                        }

                        this.form.html(newblock.html());
                    }else{

                        this.form.replaceWith(newblock);

                    }

                }

                this._formResponse = resp;

                if(resp.isValid()){
                    this._formSaved = true;
                    this.events.call(AjaxForm.EVENT_SAVE)
                }else{
                    this._formSaved = false;
                    this.events.call(AjaxForm.EVENT_ERRORS)
                }
            })

    }


    defaultProps(): Partial<AjaxFormProps> {
        return {
            dialog: true
        }
    }

    get formResponse(): DceAjaxResponse {
        return this._formResponse;
    }

    get formSaved(): boolean {
        return this._formSaved;
    }
}
